/* eslint-disable no-mixed-spaces-and-tabs */
import Feature from 'proximiio-js-library/lib/models/feature';
import { create } from 'zustand';

// import { devtools } from 'zustand/middleware';
// define types for state values and actions separately
type State = {
	features: Feature[];
};

type Actions = {
	setFeatures: (features: Feature[]) => void;
};

// define the initial state
const initialState: State = {
	features: [],
};

const useFeaturesStore = create<State & Actions>()(
	//devtools(
	(set) => ({
		...initialState,
		setFeatures: (features) => {
			set(() => ({ features }));
		},
	})
	//{ name: 'mapStore' }
	//)
);

export default useFeaturesStore;
